// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1X3Hu","inputWrap":"Table_inputWrap__jO1QT","col":"Table_col__1BiRh","bmiTooltip":"Table_bmiTooltip__2Fis4"};